const PortfolioTabs = Object.freeze({
    DETAIL: 0,
    NOTES: 1,
});

export default PortfolioTabs;
